import { Helmet } from 'react-helmet';
import { TitleQuote } from '../components/homepage/TitleQuote';
import { HeroSection } from '../components/homepage/HeroSection';
import { ThirdSection } from '../components/homepage/ThirdSection';
import { FourthSection } from '../components/homepage/FourthSection';
import { FifthSection } from '../components/homepage/FifthSection';
import { SixthSection } from '../components/homepage/SixrthSection';

const Home = () => {
  return (
    <>
      <Helmet>
        <title>Lone Wolf Writes</title>
        <meta name="description" content="Welcome to Lone Wolf Writes, a vibrant space where the power of words takes center stage, and creativity knows no bounds. We are a platform that celebrates the beauty of language, offering a diverse collection of blogs, poems, and quotes crafted in both Marathi and English. Through our work, we aim to connect with readers on an emotional level, inspiring them to explore, reflect, and grow through the magic of storytelling and poetic expression." />
        <link rel="canonical" href="https://lonewolfwrites.com/" />
      </Helmet>
      <main>
        <HeroSection />
        <TitleQuote />
        <FifthSection />
        <SixthSection />
        <FourthSection />
        <ThirdSection />
      </main>
    </>
  )
};

export default Home;